<template>
  <b-container fluid>
    <!-- TODO: whenmultiple, this row should go on forever! -->
    <!--  style="width: 100%;" -->
    <b-row no-gutters v-if="obj && !obj.loading">
        <!-- TODO: header here! -->
          <!-- TODO: if the section is a Modal:
            trigger it from the dropdown menu in the header of main section? -->
      <b-card no-body class="col-12 my-0" :class="{ 'border-0': !showHeader }">
          <!-- TODO: toggle editor open? -->
            <!-- @click="toggleEditorSectionOpen({ section })" -->
            <!-- TOOD: pass multiple here even if it isn't? -->
        <b-card-header v-if="collapsableSections.length > 0" class="p-0">
          <b-button-toolbar class="float-md-left">
            <b-button title="Collapse All" @click="toggleCollapseAll" variant="link">
              <template v-if="allCollapsed">
                <b-icon icon="file-plus" /> Open All Sections
              </template>
              <template v-else>
                <b-icon icon="file-minus" /> Collapse All Sections
              </template>
            </b-button>
          </b-button-toolbar>
        </b-card-header>
        <b-card-header
          v-if="headerVisible"
          @click="open = !open"
          header-tag="nav"
          :class="{ 'field-changed': changed, 'field-invalid': !valid }"
          class="py-1"
          :title="editor.DisplayName"
        >
          <!-- TODO: move some of this to another component? -->
          <template v-for="section in headerSections">
            <template v-for="editorField in section.Fields">
              <!-- TODO: separtion of more than one field here. -->
              {{obj[editorField.EntityProperty.PropertyName]}}
            </template>
          </template>
          <b-badge variant="outline-primary">
            <b-icon :icon="editor.Icon" variant="info" aria-hidden="true"></b-icon>
          </b-badge>
          <b-button-toolbar v-if="modalSections.length > 0" class="float-md-right">
            <b-dropdown right text="Tools" class="tools-dropdown" variant="link" size="sm">
              <template v-slot:button-content>
                <!-- TODO: just for Editing -->
                <b-icon icon="pencil-square" />
              </template>
              <editor-section-modal
                v-for="(section, index) in modalSections"
                :key="'ddli-' + section.EditorSectionId + '-' + index"
                :section="section" :obj="obj" :originalObj="originalObj"
                :editor="editor"
                @changed="changed => onSectionChanged(index, changed)"
                @validated="valid => onSectionValidated(index, valid)"
                fieldCols="4"
                @sectionMounted="sectionMounted"
                :addChildObject="addChildObject"
                :addChildObjects="addChildObjects"
                :removeChildObject="removeChildObject"
                :readdChildObject="readdChildObject"
                @save="(obj, section) => save(obj, section)"
              />
            </b-dropdown>
          </b-button-toolbar>
        </b-card-header>
        <!-- note: editor-section contains the body -->
        <b-collapse :visible="open">
          <b-card-body class="p-0" v-show="sectionSections.length > 0">
            <b-container fluid>
              <b-row no-gutters v-for="(section, i) in sectionSections" :key="section.EditorSectionName + obj.instanceKey">
                <editor-section
                  :section="section" :obj="obj" :originalObj="originalObj"
                  :editor="editor"
                  @changed="changed => onSectionChanged(i, changed)"
                  @validated="valid => onSectionValidated(i, valid)"
                  fieldCols="4"
                  @sectionMounted="sectionMounted"
                  :addChildObject="addChildObject"
                  :addChildObjects="addChildObjects"
                  :removeChildObject="removeChildObject"
                  :readdChildObject="readdChildObject"
                  @save="(obj, section) => save(obj, section)"
                  :readOnly="readOnly"
                  :cancel="cancel"
                  :showAddButton="showAddButton"
                />
              </b-row>
            </b-container>
          </b-card-body>
        </b-collapse>
      </b-card>
                  <!-- :removeChildObject="removeChildObject" -->
    </b-row>
    <b-row v-else>
      <loading-text></loading-text>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import EditorSection from '@/components/editor/utility/editor-section.vue'
import EditorSectionModal from '@/components/editor/utility/editor-section-modal.vue'
import FieldComponentReadyOnly from '@/components/editor/utility/field-components/read-only.vue'
import LoadingText from '@/components/utility/loading-text.vue'

import MxEditorComponent from '@/mixins/editor-component'

@Component({
  components: {
    'editor-section': EditorSection,
    'editor-section-modal': EditorSectionModal,
    'field-component-read-only': FieldComponentReadyOnly,
    'loading-text': LoadingText,
  },
})
export default class extends Mixins(MxEditorComponent) {
  public changed = false
  public valid = true

  // simple array, since we don't add/remove fields on the fly, index doesn't change
  public changedSections: boolean[] = []
  public validSections: boolean[] = []
  // public originalObjInternal!: any
  public mountedSections: boolean[] = []
  public open = false

  // For the search request, we dont need to enforce permissions, so using this as a workaround
  @Prop({ default: true })
  public shouldEnforcePermissions!: boolean

  @Prop({ default: false })
  public showHeader!: boolean

  @Prop()
  public cancel!: any

  @Prop({ default: true })
  public showAddButton!: boolean

  public mounted() {
    this.open = this.parentObj === undefined // top most level starts open!
    Vue.set(this, 'mountedSections', new Array(this.editor.Sections.length).fill(false))
    Vue.set(this, 'mountedSections', new Array(this.sectionSections.length).fill(false))
  }

  public toggleCollapseAll() {
    const value = this.allCollapsed
    this.sectionSections.forEach(section => this.setEditorSectionOpen({ section, value }))
  }

  public onSectionChanged(i: number, changed: boolean) {
    this.changedSections[i] = changed
    this.changed = this.changedSections.some(v => v)
    this.onChanged(this.changed)
  }

  public onSectionValidated(i: number, valid: boolean) {
    this.validSections[i] = valid
    this.valid = !this.validSections.some(v => !v)
    this.onValidated(this.valid)
  }

  public sectionMounted() {
    this.$emit('sectionMounted')
  }

  get sections() {
    // TODO: not the best place to do EffectivePermission
    // hide sections that have no Properties or at least no ones that can be Read

    // TODO: https://dev.azure.com/Ricoh-TPI/TPI/_workitems/edit/115
    return this.shouldEnforcePermissions
      ? this.editor.Sections
        .filter(s =>
          s.EffectivePermission.CanRead &&
          // TODO: this is just for build 11.5 - we need to better hide this functionality!
          // - as this will incorrectly hide it for ALL new interfaces!
          s.Fields.filter(p => p.EffectivePermission.CanRead).length > 0, // needed?
        )
      : this.editor.Sections
  }

  get headerSections() {
    return this.sections.filter(s => s.SectionType === 'Header')
  }

  get modalSections() {
    return this.sections.filter(s => s.SectionType === 'Modal')
  }

  get sectionSections() {
    return this.sections.filter(s => s.SectionType === 'Section')
  }

  get collapsableSections() {
    return this.sections.filter(s => s.SectionType === 'Section' && s.DisplayName !== '')
  }

  get allCollapsed() {
    return this.collapsableSections.every(s => !s.open)
  }

  get headerVisible() {
    return (this.showHeader &&
      this.editor.DisplayName &&
      this.editor.DisplayName.length > 0) ||
      this.modalSections.length > 0
  }
}
</script>
<style>

</style>
